import React from 'react';
import { Field, FieldProps } from 'formik';
import { ButtonGroup, RadioButton } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import styles from './FormikRadioGroupYesNo.css';

interface IProps {
    name: string;
    disabled?: boolean;
    yesText: string;
    noText: string;
}

const FormikRadioGroupYesNo: React.FunctionComponent<IProps> = ({ name, disabled = false, noText, yesText }) => {
    const { t } = useTranslation();
    return (
        <Field name={name}>
            {({ field, form }: FieldProps) => {
                return (
                    <ButtonGroup
                        dataTestId='radio-group'
                        name={name}
                        handleClickCallback={(value) => {
                            form.setFieldValue(field.name, value === 'true');
                        }}
                        disabled={disabled}
                        className={styles.buttonGroup}
                    >
                        <RadioButton
                            inline
                            name={yesText}
                            value='true'
                            checked={field.value}
                            text={t('Yes')}
                            id='radio-yes'
                        />
                        <RadioButton
                            inline
                            name={noText}
                            value='false'
                            checked={!field.value}
                            text={t('No')}
                            id='radio-no'
                        />
                    </ButtonGroup>
                );
            }}
        </Field>
    );
};

export default FormikRadioGroupYesNo;
